import { BoxProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const styles = (): any => {
  return {
    container: {
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: 'LIGHT_GREY',
      borderRadius: 4,
      zIndex: 4,
      backgroundColor: '#FFFFFF',
      height: '100vh',
      width: 650,
      overflow: 'auto',
    } as ViewStyle,
    headerContainer: {
      // flex: 1,
      padding: 0,
      margin: 24,
      marginRight: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      //   ...overRideHeaderContainer,
    } as BoxProps,
  }
}

export { styles }
